import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  Input,
  Label,
  FormGroup,
} from "reactstrap";

const Cadastrar = (props) => {
  // ** Const
  // ** Props
  const { open, setOpen } = props;
  const [card, setCard] = useState({});

  useEffect(() => {
    setCard({
      name: "",
      width: "12",
      height: null,
      tipoAba: true,
      ordem: props.maxSize + 1,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const handleSubmit = (e) => {
    e.preventDefault();
    let area = localStorage.getItem("area");
    let menus = JSON.parse(localStorage.getItem("menus"));
    let menuSelecionado = menus?.find(
      (item) =>
        // eslint-disable-next-line eqeqeq
        item.area == localStorage.getItem("area") &&
        // eslint-disable-next-line eqeqeq
        item.id == localStorage.getItem("idMenu")
    );
    if (card.ordem === props.maxSize + 1) {
      let model = {
        params: {
          arg1: area,
          arg2: menuSelecionado?.menu,
          arg3: card.name,
          arg4: card.width,
          arg5: card.height,
          arg6: card.tipoAba,
          arg7: card.ordem,
        },
      };
      props.createCard(model);
    } else {
      const from = props.maxSize + 1;
      const to = card.ordem;
      card.ordem = props.maxSize + 1;
      props.handleOrderCard(card, Number(from), Number(to), true);
    }
    setOpen(false);
  };

  return (
    <Modal
      isOpen={open}
      toggle={() => setOpen(!open)}
      className={`modal-dialog-centered`}
      size="lg"
    >
      <ModalHeader toggle={() => setOpen(!open)}>Cadastrar Card </ModalHeader>
      <ModalBody>
        <Form id="form" className="mb-2">
          <FormGroup>
            <Label for="nome">Título</Label>
            <Input
              type="text"
              id="name"
              placeholder="Título"
              value={card.name}
              name="name"
              onChange={(e) =>
                setCard({
                  ...card,
                  [e.target.name]: e.target.value,
                })
              }
            />
          </FormGroup>
          <FormGroup>
            <Label for="width">Largura</Label>
            <Input
              type="number"
              id="width"
              placeholder="Largura de 1 a 12"
              value={card.width}
              name="width"
              onChange={(e) =>
                setCard({
                  ...card,
                  [e.target.name]: e.target.value,
                })
              }
            />
          </FormGroup>
          <FormGroup>
            <Label for="height">Altura</Label>
            <Input
              type="text"
              id="height"
              placeholder="Altura em pixels"
              value={card.height}
              name="height"
              onChange={(e) =>
                setCard({
                  ...card,
                  [e.target.name]: e.target.value,
                })
              }
            />
          </FormGroup>
          <FormGroup>
            <Label for="ordem">Ordem</Label>
            <Input
              type="number"
              id="ordem"
              placeholder="Ordenação na página"
              value={card.ordem}
              name="ordem"
              onChange={(e) => {
                const value =
                  e.target.value < 1 || e.target.value > props.maxSize + 1
                    ? card.ordem
                    : e.target.value;
                setCard({
                  ...card,
                  [e.target.name]: value,
                });
              }}
            />
          </FormGroup>
          <FormGroup className="ml-4 mt-3">
            <Label>
              <Input
                type="checkbox"
                checked={card.tipoAba}
                onChange={(e) =>
                  setCard({
                    ...card,
                    tipoAba: !card.tipoAba,
                  })
                }
              />
              Tipo abas{" "}
              <span style={{ fontSize: "9px" }}>
                *(Existem dois tipos de formato de abas: padrão e menu dropdown.
                Se 'Tipo abas' estiver marcado, o formato das abas será padrão.
                Caso contrário, as abas serão mostradas dentro de um menu
                dropdown.)
              </span>
            </Label>
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button type="submit" onClick={(e) => handleSubmit(e)} color="primary">
          Cadastrar
        </Button>
      </ModalFooter>
    </Modal>
  );
};
export default Cadastrar;
